<div
  *ngIf="notificationId"
  class="delete-notification">
  <h2 class="headline">
    {{'NOTIFICATION_PAGE.MODAL_DELETE_ITEM.TITLE' | translate}}
  </h2>
  <p class="description">
    {{'NOTIFICATION_PAGE.MODAL_DELETE_ITEM.DESCRIPTION' | translate}}
  </p>
  <div class="btn-block">
    <button
      (click)="deletePaylink()"
      class="btn btn-danger">
      {{'NOTIFICATION_PAGE.MODAL_DELETE_ITEM.DELETE' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'NOTIFICATION_PAGE.MODAL_DELETE_ITEM.CANCEL' | translate}}
    </button>
  </div>
</div>
